function ImageIcon() {
  return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.6431 19.1429H3.14307C2.59078 19.1429 2.14307 18.6952 2.14307 18.1429V4.14288C2.14307 3.5906 2.59078 3.14288 3.14307 3.14288H19.1431C19.6954 3.14288 20.1431 3.5906 20.1431 4.14288V11.6429"
                stroke="#262320" strokeLinecap="round"/>
            <path d="M3.14307 18.6429L13.2895 8.49644C13.4848 8.30117 13.8014 8.30117 13.9966 8.49644L16.6431 11.1429"
                  stroke="#262320" strokeLinecap="round"/>
            <circle cx="7.14307" cy="8.14288" r="1.5" stroke="#262320"/>
            <path d="M17.998 13.1429V20.8572" stroke="#262320" strokeLinecap="round"/>
            <path d="M14.1426 17.0003L21.8569 17.0003" stroke="#262320" strokeLinecap="round"/>
        </svg>
  );
}

export default ImageIcon;
